<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="active" @click="onClickTab(2)">
        <a data-toggle="tab" href="#serviceFeeInvoice"
          ><b>{{ $t("feedback.config.subjectList") }}</b></a
        >
      </li>
      <li
        v-if="
              GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.extra_info_list !==
                undefined &&
              GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.extra_info_list.includes(
                keyCheckShowApartmentExtraInfo
              )
        "
        @click="onClickTab(3)">
        <a data-toggle="tab" href="#position"
          ><b>{{ $t("position.title") }}</b></a
        >
      </li>
    </ul>

    <div class="tab-content">
      <div id="serviceFeeInvoice" class="tab-pane fade in active">
        <subject-list ref="subjectList" />
      </div>
      <div id="position" class="tab-pane fade">
        <position-list ref="positionList" />
      </div>
    </div>
  </div>
</template>
<script>

import SubjectList from "./SubjectList";
// import DepartmentList from "./DepartmentList";
import PositionList from "../Position/PositionList"
import { mapGetters } from 'vuex';
import Enum from "../../../enum/enum";

export default {
  components: {
    SubjectList,
    // DepartmentList,
    PositionList
  },
  data: () => ({
    keyCheckShowApartmentExtraInfo: Enum.defaultExtraInfoList.USER_EXTRA_INFO
  }),
  computed: {
    ...mapGetters([
      'GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA'
    ])
  },
  methods: {
    onClickTab: function(value) {
      switch (value) {
        case 1:
          // this.$refs.departmentList.onRefreshData();
          break;
        case 2:
          this.$refs.subjectList.onRefreshData();
          break;
        case 3:
          this.$refs.positionList.onRefreshData();
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.$refs.subjectList.onRefreshData();
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/Case/ConfigDepartmentAndSubject.vue